var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30872_179177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0096 15.9998C12.1013 16.0098 11.2404 15.6155 10.6828 14.9341C10.1253 14.2527 9.93546 13.3628 10.1697 12.5289L4.91461 9.67537C4.00654 10.4658 2.67547 10.633 1.58232 10.0942C0.489159 9.55528 -0.133241 8.42502 0.0241544 7.26459C0.18155 6.10415 1.08522 5.16072 2.28646 4.90272C3.4877 4.64473 4.73065 5.12712 5.39815 6.11039L10.1689 3.5192C10.1071 3.29764 10.0744 3.06968 10.0715 2.8405C10.0595 1.506 11.035 0.346726 12.4079 0.0641435C13.7808 -0.218439 15.1739 0.453277 15.7443 1.67284C16.3148 2.89241 15.9058 4.32489 14.765 5.10351C13.6241 5.88213 12.0646 5.79304 11.0302 4.89016L5.86658 7.6935C5.86146 7.90032 5.83104 8.10587 5.77591 8.306L11.0302 11.1588C11.9975 10.3154 13.4367 10.1852 14.5542 10.84C15.6716 11.4948 16.1951 12.7752 15.836 13.9749C15.4769 15.1746 14.3225 16.0016 13.0096 15.9998ZM13.0096 12.0121C12.3142 12.0121 11.7504 12.5477 11.7504 13.2084C11.7504 13.8691 12.3142 14.4047 13.0096 14.4047C13.7051 14.4047 14.2689 13.8691 14.2689 13.2084C14.2689 12.5477 13.7051 12.0121 13.0096 12.0121ZM2.93598 6.42941C2.24053 6.42941 1.67677 6.96501 1.67677 7.62571C1.67677 8.28641 2.24053 8.82201 2.93598 8.82201C3.63142 8.82201 4.19519 8.28641 4.19519 7.62571C4.19519 6.96501 3.63142 6.42941 2.93598 6.42941ZM13.0096 1.6442C12.3142 1.6442 11.7504 2.1798 11.7504 2.8405C11.7504 3.5012 12.3142 4.0368 13.0096 4.0368C13.7051 4.0368 14.2689 3.5012 14.2689 2.8405C14.2689 2.1798 13.7051 1.6442 13.0096 1.6442Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30872_179177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.ef93944d04f01582e8cc9d91cefd657e.svg";
export { ForwardRef as ReactComponent };